import React           from 'react';
import { makeStyles }  from '@material-ui/core/styles';
import colors          from '../utils/colors';


const langs: { [key: string]: string } = { heb: `עברית`, arab: `عربي` }
 
const useStyles = makeStyles(() => ({
    selector: {
       felx:            1,
       height:          '100%',
       paddingLeft:     15,
       paddingRight:    15,
       color:           colors.dark,
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       textAlign:       'center',
       cursor:          'pointer',
       fontSize:        23,
       '&:hover': {
        color: colors.blue
       }
    }
}))

type LangSelectorProps = {
    variant:  string;
    lang:     string;
    setLang:  (val: string) => void;
}

const LangSelector: React.FC<LangSelectorProps> = ({ variant, lang, setLang }) => {

  const classes = useStyles();

  const handleClick = () => {
      if (lang === 'heb') {
          setLang('arab')
      }
      else {
        setLang('heb')
      }
  }

  return (
        <div 
            className = { classes.selector }
            onClick   = { handleClick }
        >
            { langs[variant] }
        </div>
  );
}



export default LangSelector;
